<template>
    <div>
        <div class="ix-table-box mb-4">
            <table class="ix-table ix-table-align-middle">
                 <thead>
                    <tr>
                        <th>Rapport d'intervention</th>
                        <th>Durée</th>
                        <th></th>
                    </tr>
                </thead>
                 <tbody>
                    <tr v-for="(interventionLine,index) in lineInterventions"  is="precheckings-intervention-form" :key="index"
                        :intervention="interventionLine"
                        :index="index"
                        v-on:open-movement-intervention-checking-modal="openMovementModal($event)"
                        :duration="arrayDurations[index]"
                        :articleUrl="urlArticle"
                        :max-hours-per-day="maxHoursPerDay">
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="modal fade" id="checkingInterventionMovementModal" tabindex="-1" aria-labelledby="showAbsenceModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header" v-if="!loadingForm">
                        <h5 class="modal-title">Sortie de stocks - {{ intervention.designation }} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="operationMovementMotif">Motif</label>
                                    <input class="form-control" type="text" v-model="form.designation" id="operation_movements_designation">
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="operation_movements_date_at">Date</label>
                                    <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa" id="operation_movements_date_at" v-model="form.date_at">
                                </div>
                            </div>
                            
                            <template v-if="form.articles && form.articles.length > 0">
                                <div class="col-sm-12">
                                    <hr>
                                    <h5>Liste des articles</h5>
                                </div>
                                <div v-for="(article, i) in form.articles" :key="i" class="col-sm-12">     
                                    <div class="form-group">
                                        <label :for="article.name">{{ article.name }}</label>
                                        <input type="number" v-model="article.quantity" class="form-control" style="width: 100% !important" step="0.01" min="0" :id="'quantity' + article.id" />
                                    </div>
                                 
                                </div>
                            </template>

                          
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="operationMovementArticle">Ajouter un article</label>
                                    <input placeholder="Commencer la saisie pour obtenir des suggestions .." onkeydown="return event.key != 'Enter';" class="form-control" id="articleInterventionSearchInput" type="text" v-model="form.article">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="ix-btn green" v-bind:disabled="loadingForm || !checkForm()" @click="addMovement()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

     
</template>

<script>
import PrecheckingsInterventionForm from "./PrecheckingsInterventionForm";


export default {
    name: 'PrecheckingsInterventionTable',
    props: ['oldInterventions', 'interventions', 'articleUrl', 'durations', 'maxHoursPerDay'],
    components: {
        PrecheckingsInterventionForm
    },
    data(){
         return {
            lineInterventions : [],
            urlArticle : this.articleUrl,
            arrayDurations: [],
            intervention: null, 
            loadingForm: true,
            index: null,
            form: {
                    date_at: null,
                    designation: null,
                    articles: [],
                    article: null,
            },
        }
    },
    methods:{
        openMovementModal(e){
            console.log(e);
           this.initForm();
           this.intervention = e.intervention;
           this.index = e.index;
           this.form = this.fillForm(this.intervention);
           this.loadingForm = false;
           $('#checkingInterventionMovementModal').modal();

           setTimeout(function() { $("#articleInterventionSearchInput").focus(); }, 500);
       },
        fillForm(intervention = null){
           return {
               designation : intervention.movements && intervention.movements.designation ? intervention.movements.designation : intervention.designation,
               date_at : intervention.movements && intervention.movements.date_at ? intervention.movements.date_at : this.moment().format('DD/MM/YYYY'),
               articles : intervention.movements && intervention.movements.articles ? intervention.movements.articles : []
           };
       },
       initForm(){
           this.form.date_at = null;
           this.form.designation = null;
           this.form.article = null;
           this.form.articles = [];
       },
        addArticle: function (article, focus = false) {
            if (this.getCurrentSelectedArticlesId().includes(article.id) == false) {
                this.form.articles.push({
                    id: article.id,
                    name: article.name,
                    quantity: article.quantity ? article.quantity : 1,
                })

            }
        },
        addMovement(){
            this.intervention.movements.designation = this.form.designation;
            this.intervention.movements.date_at = this.form.date_at;
            this.intervention.movements.articles = this.form.articles;
            $('#checkingInterventionMovementModal').modal('hide');
       },
       checkForm(){
            return this.form.articles.filter(item => item.quantity === null || item.quantity === 0 || item.quantity === '').length == 0 && this.form.articles.length > 0;
        },
        getCurrentSelectedArticlesId: function() {
            return this.form.articles.map(article => article.id);
        },
       initInputArticleIntervention: function(){
              $("#articleInterventionSearchInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.urlArticle,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedArticlesId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                response:(e , item) => {
                    if(item && item.content){
                        if(item.content.length == 1 && item.content[0].reference == $(e.target).val()){
                            $(e.target).val("");
                            this.form.article = null
                            this.addArticle(item.content[0], true);
                            setTimeout(function() { $('#quantity' + item.content[0].id).focus(); }, 100);
                        }
                    }
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.form.article = null
                    } 
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addArticle(item.item, true)
                        $(e.target).val("")
                        this.form.article = null
                        setTimeout(function() { $('#quantity' + item.item.id).focus(); }, 100);
                    }
                }
            }).focus(() => {
                $("#articleInterventionSearchInput").autocomplete("search", '');
            });
        }
    },
    mounted(){
        this.initInputArticleIntervention();
        this.lineInterventions = JSON.parse(this.interventions);
        this.arrayDurations = JSON.parse(this.durations)
        const jsonPrecheckingsBackup = JSON.parse(this.oldInterventions);
    }
}
</script>